import { useSong } from '@church/data'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { SongPage } from '../components/services/SongPage.tsx'
import { useBreadcrumbs } from '../lib/breadcrumbs.ts'

/** One of a song's arrangements: its keys, sequence, chart and files. */
export const Route = createFileRoute(
  '/_authed/_shell/services/_sections/songs/$songId/arrangements/$arrangementId',
)({
  component: ArrangementScreen,
})

function ArrangementScreen() {
  const { songId, arrangementId } = Route.useParams()
  const navigate = useNavigate()
  const song = useSong(songId).data
  const name = song?.arrangements.find((a) => a.id === arrangementId)?.name
  useBreadcrumbs([
    { label: 'Songs', href: '/services/songs' },
    { label: song?.title ?? 'Song', href: `/services/songs/${songId}` },
    { label: name ?? 'Arrangement' },
  ])
  return (
    <SongPage
      key={songId}
      songId={songId}
      arrangementId={arrangementId}
      openArrangement={(next) =>
        void navigate(
          next
            ? {
                to: '/services/songs/$songId/arrangements/$arrangementId',
                params: { songId, arrangementId: next },
              }
            : { to: '/services/songs/$songId', params: { songId } },
        )
      }
      onDeleted={() => void navigate({ to: '/services/songs' })}
    />
  )
}
